import React from "react";
import Frame from "./styled/IFrame";

const Documentation = () => {
  return <Frame url="https://doc.neuromore.com/" />;
};

export default Documentation;
